const accessDashboard = {

    DASHBOARD: {
        path: '/dashboard'
    },

    DASHBOARDSECOND: {
        path: '/'
    },

    STUDENT_DASHBOARD: {
        path: '/student-dashboard'
    }
    
}

export default accessDashboard;